import { render, staticRenderFns } from "./BonusMulti2.vue?vue&type=template&id=6d2778d2&"
import script from "./BonusMulti2.vue?vue&type=script&lang=js&"
export * from "./BonusMulti2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports